/**
 * Created by calhosh on 8/5/2025
 */

import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import {isApiResponseOk, normalize, normalizedDelete} from '../../util/utils';
import * as constants from '../../util/uiconstants';

export default function manageControlsReducer(state = initialstate.manageControls, action) {
	let newState;

	switch (action.type) {
		case types.GET_MANAGE_CONTROLS: {
			if (action.response && action.response.data) {
				newState = {...state};

				const controlList = normalize(action.response.data.map((control) => mapControl(control)));
				controlList.page = action.response.page;
				controlList.pages = action.response.pages;
				controlList.totalEntityCount = action.response.totalEntityCount;

				newState = {...controlList};

				return newState;
			}
			return state;
		}
		case types.DELETE_CONTROL_BY_ID: {
			if (isApiResponseOk(action) || action.error.response.status === constants.HttpStatusCodes.NotFound) {
				newState = {...state};
				newState = deleteControl(newState, action.controlId);
				return newState;
			}
			return state;
		}
		case types.UPDATE_CONTROL: {
			if (isApiResponseOk(action)) {
				const payload = action.meta.api.data;
				const {response} = action;
				const control = state.byId?.[payload.id];
				if (control) {
					return {
						...state,
						byId: {
							...state.byId,
							[payload.id]: {
								...control,
								controlName: response.controlName,
								controlTypeId: response.controlTypeId,
								controlDesignEffectivenessTypeId: response.controlDesignEffectivenessTypeId,
								controlFrequencyTypeId: response.controlFrequencyTypeId,
								hasControlTesting: response.hasControlTesting,
								itApplications: payload.ITApplicationOrSOIds,
								isEffective: response.isEffective,
								isLowerRisk: response.isLowerRisk,
								isIPEManuallyTested: response.isIPEManuallyTested,
								entityName: response.controlName
							}
						}
					};
				}
			} else if (action?.error?.response?.status === constants.HttpStatusCodes.BadRequest) {
				return deleteControl(state, action?.meta?.api?.data?.id); // this is to remove the control from the list if it is not found (concurrency scenario)
			}
			return state;
		}
		case types.CREATE_CONTROL: {
			if (isApiResponseOk(action)) {
				newState = normalize([action.response], undefined, state);
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}

function mapControl(control) {
	const mappedControl = {...control};

	if (control.entities) {
		mappedControl.entities = control?.entities?.map((entity) => entity.id);
	}

	return mappedControl;
}

/**
 * Deletes a control from a normalized state.
 * @param {Object} state Normalized controls state.
 * @param {number} controlId Control id.
 * @returns	{Object} Updated normalized controls state.
 */
function deleteControl(state, controlId) {
	return normalizedDelete(state, controlId);
}
